var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPull(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pull-overlay",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 19,
    viewBox: "0 0 25.768 18.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "pull1",
    x: 0.5,
    y: 8.992,
    width: 24,
    height: 0.946,
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pull2",
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 0.946,
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pull3",
    x: 0.5,
    y: 17.484,
    width: 24,
    height: 0.946,
    stroke: "#000",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPull);
export default __webpack_public_path__ + "static/media/pull.f6ff9744d0d9536c3037a2abba1da91b.svg";
export { ForwardRef as ReactComponent };